export class SurveyServices {

    static async GetSlideData(filename) {
        try {
            let url = process.env.REACT_APP_PUBLIC_CDN_URL + 'survey/' + filename;
            const response = await fetch(url);
            const data = await response.json();
            return data;
        } catch (error) {
            throw (error);
        }
    }

    static GetSurveyIconUrl(filePath) {
        if (!filePath) { filePath = 'survey/surveyIcons/locationPin.png'; }
        let url = process.env.REACT_APP_PUBLIC_CDN_URL + filePath;
        return url;
    }

    static GetFeatureAvatarUrl(filePath) {
        if (!filePath) { filePath = 'survey/surveyAvatars/parentsLocationSharing.webp'; }
        let url = process.env.REACT_APP_PUBLIC_CDN_URL + filePath;
        return url;
    }

    static GetFeatureImageUrl(filePath) {
        if (!filePath) { filePath = 'survey/featuresImages/parentsLocationSharing.webp'; }
        let url = process.env.REACT_APP_PUBLIC_CDN_URL + filePath;
        return url;
    }

}
